import { BehaviorSubject } from "rxjs";
import { MENU } from "src/app/admin/layouts/shared/horizontalnavbar/menu";
import { MenuItem } from "src/app/admin/layouts/shared/horizontalnavbar/menu.model";
import { Injectable } from '@angular/core';
export class FecthDataService {
  private ServiceCreatedSubject = new BehaviorSubject<boolean>(false);
  actionCreated$ = this.ServiceCreatedSubject.asObservable();

  notifySeriviceCreated() {
    this.ServiceCreatedSubject.next(true);
  }
}

export class MenuService {
  private menuItemsSubject = new BehaviorSubject<MenuItem[]>([]);
  public menuItems$ = this.menuItemsSubject.asObservable();

  updateMenu(userGroup: string, userDirection: string, accessExecution: any): void {

    // ══════════════════════════════════════════
    // ADMIN → accès total, rien à filtrer
    // ══════════════════════════════════════════
    if (userGroup === 'admin') {
      this.menuItemsSubject.next(this.deepClone(MENU));
      return;
    }

    // ══════════════════════════════════════════
    // NON-ADMIN
    // ══════════════════════════════════════════
    const isDAAF = userDirection === 'DAAF';
    const DAAF_ONLY = ['Engagements', 'Ordonnancements', 'Décaissements'];
    const EXECUTION_EDITION = ['Exécution', 'Edition'];

    const result = MENU.map(item => {

      const cloned = this.deepClone(item);

      // ── Exécution & Edition : accessibles pour non-admin ──────────────
      if (EXECUTION_EDITION.includes(item.label)) {

        if (item.label === 'Exécution') {
          // Sous-menus : bloquer Engagements/Ordonnancements/Décaissements si non-DAAF
          cloned.subItems = cloned.subItems?.map((sub: MenuItem) => {
            if (DAAF_ONLY.includes(sub.label) && !isDAAF) {
              return {
                ...sub,
                disabled: true,
                link: null,
                accessMessage: `Accès refusé. Seuls les administrateurs et les agents du service DAAF ont accès à "${sub.label}".`
              };
            }
            return sub; // autres sous-menus → accès normal
          });
        }

        // Edition → accessible telle quelle pour tous les non-admins
        return cloned;
      }

      // ── Tous les autres menus → visibles mais grisés ──────────────────
      cloned.disabled = true;
      return cloned;

    });

    this.menuItemsSubject.next(result);
  }

  private deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }
}